<template>
  <v-card>
    <v-card-title>
      <h2>Demonstration Video</h2>
      <v-spacer />
      <v-btn outlined color="primary" @click="$emit('close')">Close</v-btn>
    </v-card-title>
    <v-card-text style="height:400px;">
     <video width="100%" height="auto" controls>
            <source :src="url" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: 'VideoViewer',
    props: ["url"]
};
</script>